import { Box } from '@mui/material';
import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Header } from './components/Header.js';
import { DashboardEditorPage } from './features/editor/DashboardEditorPage.js';
import { IntelligenceDashboardPage } from './features/intelligence/IntelligenceDashboardPage.js';
import { StorylineChatProvider } from './features/intelligence/components/StorylineChatContext.tsx';
import { MarketDashboardPage } from './features/market/MarketDashboardPage.js';
import { MarketOverviewRoute } from './features/market/MarketOverviewRoute.js';
import { usePortfolioStore } from './features/portfolios/portfolioStore.js';
import { PredictionMarketsDashboardPage } from './features/prediction-markets/PredictionMarketsDashboardPage.js';
import { CanvasRouteHandler } from './features/profiles/CanvasRouteHandler.js';
import { IntelligenceCategoryPage } from './features/profiles/IntelligenceCategoryPage.js';
import { ProfileDashboardPage } from './features/profiles/ProfileDashboardPage.js';
import { ProfileLegacyDetailPage } from './features/profiles/ProfileLegacyDetailPage.js';
import { ProfilePreviewCanvas } from './features/profiles/ProfilePreviewCanvas.js';
import { ProfilesPage } from './features/profiles/ProfilesPage.js';
import { StewardDashboardPage } from './features/steward/StewardDashboardPage.js';
import { isMarketLandingEnabled, isStewardConsoleEnabled } from './utils/featureFlags.js';

function App() {
  const useMarketLanding = isMarketLandingEnabled();
  const stewardEnabled = isStewardConsoleEnabled();
  const initializePortfolios = usePortfolioStore((state) => state.initialize);

  React.useEffect(() => {
    initializePortfolios().catch((error) => {
      console.warn('[App] Failed to initialize portfolios', error);
    });
  }, [initializePortfolios]);

  return (
    <BrowserRouter>
      <StorylineChatProvider>
        <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
          <Header />
          <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            <Routes>
              <Route path="/" element={<Navigate to={useMarketLanding ? '/market' : '/canvas'} replace />} />
              {useMarketLanding && (
                <>
                  <Route path="/market" element={<MarketDashboardPage />} />
                  <Route path="/market/legacy" element={<MarketOverviewRoute />} />
                </>
              )}
              <Route path="/profiles" element={<ProfilesPage />} />
              <Route
                path="/profiles/:id/intelligence/:domain"
                element={<IntelligenceCategoryPage />}
              />
              <Route
                path="/profiles/:id"
                element={<ProfileDashboardPage />}
              />
              <Route path="/profiles/:id/legacy" element={<ProfileLegacyDetailPage />} />
              <Route path="/profiles/:id/preview" element={<ProfilePreviewCanvas />} />
              <Route path="/canvas" element={<CanvasRouteHandler />}> </Route>
              <Route path="/editor" element={<DashboardEditorPage />} />
              <Route path="/intelligence" element={<IntelligenceDashboardPage />} />
              {stewardEnabled && (
                <Route path="/steward" element={<StewardDashboardPage />} />
              )}
              <Route path="/prediction-markets" element={<PredictionMarketsDashboardPage />} />
            </Routes>
          </Box>
        </Box>
      </StorylineChatProvider>
    </BrowserRouter>
  );
}

export default App;
